
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import InvestorsList from "@/components/InvestorsList";
import { Investor, Contact } from "@/types/investor";
import { EmailRecord } from "@/types/email";

interface DataTabsProps {
  investors: Investor[];
  contacts: Contact[];
  emails: EmailRecord[];
  selectedInvestor: Investor | null;
  selectedEmail: EmailRecord | null;
  relevanceContext: string;
  isEnriching: boolean;
  onSelectInvestor: (investor: Investor | null) => void;
  onInvestorUpdate: (investor: Investor) => void;
  onProcessInvestor: (investor: Investor) => Promise<Investor | undefined>;
  onEnrichInvestor: (investor: Investor) => Promise<Investor | undefined>;
  onViewEmail: (email: EmailRecord) => void;
  onCloseEmailDetails: () => void;
  onEmailUpdated: (email: EmailRecord) => void;
  onProviderUpdated: () => void;
  setIsEnriching: (isEnriching: boolean) => void;
}

const DataTabs: React.FC<DataTabsProps> = ({
  investors,
  contacts,
  selectedInvestor,
  relevanceContext,
  isEnriching,
  onSelectInvestor,
  onInvestorUpdate,
  onProcessInvestor,
  onEnrichInvestor,
  setIsEnriching
}) => {
  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle>Investors</CardTitle>
        <CardDescription>
          {relevanceContext 
            ? "Investors sorted by relevance to your criteria" 
            : "Select an investor to generate an email template"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <InvestorsList 
          investors={investors} 
          contacts={contacts} 
          selectedInvestor={selectedInvestor}
          onSelectInvestor={onSelectInvestor}
          relevanceContext={relevanceContext}
          onInvestorUpdate={onInvestorUpdate}
          isEnriching={isEnriching}
          setIsEnriching={setIsEnriching}
          onProcessInvestor={onProcessInvestor}
          onEnrichInvestor={onEnrichInvestor}
        />
      </CardContent>
    </Card>
  );
};

export default DataTabs;
